import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { RouteBuilder } from 'ng-utils';
import { DashboardLayoutComponent } from './dashboard-layout/dashboard-layout.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';

const routes: Routes = [
    {
        path: '',
        component: DashboardLayoutComponent,
        children: [
            RouteBuilder.withPath('')
                .withComponent(DashboardComponent)
                .extendData({
                    title: 'Биллинг',
                    hasBreadcrumbs: false,
                    id: 0,
                })
                .build(),
        ],
    },
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class DashboardRoutingModule {}
